import styled, { css } from "styled-components";


export const GiftCardCategorySelectorRoot = styled.div(
    () => css`
        display: flex;
        gap: 5px;
        margin-top: 20px;
        margin-bottom: 2px;
        overflow-x: auto;
    `
)